import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useMainCategories } from '../context/MainCategoryContext';
import { useCollections } from '../context/CollectionsContext';

const findCategory = (categories, keyword) =>
  categories?.find((c) => c.name?.toLowerCase().includes(keyword));

const getShopTo = (mainCategory, collections) => {
  if (!mainCategory) return '/';
  const categoryCollections =
    collections?.filter((collection) => collection.mainCategoryId === mainCategory.id) || [];
  if (categoryCollections.length === 1) {
    const col = categoryCollections[0];
    return `/collections/${col.slug || col.id}`;
  }
  return `/category/${mainCategory.slug}`;
};

export const usePrimaryNavItems = () => {
  const { mainCategories, loading } = useMainCategories();
  const { collections } = useCollections();

  const preferredCategories = ['wallet', 'belt', 'bag']
    .map((keyword) => findCategory(mainCategories, keyword))
    .filter(Boolean);
  const remainingCategories = (mainCategories || []).filter(
    (category) => !preferredCategories.some((preferred) => preferred.id === category.id)
  );

  return {
    loading,
    items: [
      { label: 'Home', to: '/' },
      { label: 'Shop All', to: '/shop' },
      ...[...preferredCategories, ...remainingCategories].map((category) => ({
        label: category.name,
        to: getShopTo(category, collections),
      })),
      { label: 'Contact us', to: '/contact' },
    ],
  };
};

const isNavActive = (pathname, to) => {
  if (to === '/') return pathname === '/';
  return pathname === to || pathname.startsWith(`${to}/`);
};

const MainCategoryNavigation = () => {
  const { items, loading } = usePrimaryNavItems();
  const location = useLocation();

  const baseLink =
    'relative px-4 py-3 text-sm font-medium transition-colors duration-200 flex items-center gap-1';

  if (loading) {
    return (
      <div className="flex items-center space-x-6">
        <div className="h-4 bg-gray-200 rounded animate-pulse w-16" />
        <div className="h-4 bg-gray-200 rounded animate-pulse w-16" />
        <div className="h-4 bg-gray-200 rounded animate-pulse w-16" />
        <div className="h-4 bg-gray-200 rounded animate-pulse w-20" />
      </div>
    );
  }

  return (
    <div className="flex items-center space-x-6">
      {items.map((item) => {
        const active = isNavActive(location.pathname, item.to);
        return (
          <Link
            key={item.label}
            to={item.to}
            className={`${baseLink} ${
              active
                ? 'text-[#111111] after:absolute after:bottom-0 after:left-4 after:right-4 after:h-0.5 after:bg-[#C6A75E] after:rounded-full'
                : 'text-gray-600 hover:text-[#111111]'
            }`}
          >
            {item.label}
          </Link>
        );
      })}
    </div>
  );
};

export default MainCategoryNavigation;
